import React from "react";
import TemplateAwareApp from "./presentation/components/template-aware-app";
import { applicationConfig } from "./infrastructure/application-config";
import ServiceLocator from "./domain/service-locator";
import MinpakuAppContainer from "./presentation/custom-design/minpaku/minpaku-app-container";
import GeneralAppContainer from "./presentation/templates/general/general-app-container";
import MonotoneAppContainer from "./presentation/templates/monotone/monotone-app-container";

const AppContainer = () => {
  const uiTemplate = ServiceLocator.UiTemplateModule.uiTemplate;

  // テンプレート設定が利用可能な場合はTemplateAwareAppを使用
  // そうでなければ従来のハードコード判定を使用（後方互換性）
  const templateConfig = ServiceLocator.UiTemplateModule.templateConfiguration;

  if (templateConfig.templateKey) {
    return (
      <TemplateAwareApp
        applicationId={applicationConfig.applicationId}
        fallbackTemplate={templateConfig.templateKey}
      />
    );
  }

  switch (uiTemplate) {
    case "Minpaku":
      return <MinpakuAppContainer />;
    case "Monotone":
      return <MonotoneAppContainer designSettings={null} error={null} />;
    case "General":
    default:
      return <GeneralAppContainer />;
  }
};

export default AppContainer;
